import { Component, Input, OnInit,  } from '@angular/core';

@Component({
  selector: 'g-columnEmail',
  templateUrl: './columnEmail.component.html',
})
export class ColumnEmailComponent implements OnInit {
  constructor() { }

  @Input() data: string;
  @Input() isEditing: boolean = false;

  ngOnInit() { }
}
